import React, { FC } from 'react';
import cn from 'classnames';
import css from './styles.module.scss';

interface IAvatar {
  wasOnline: 'online' | 'recently' | 'offline';
  from: 'client' | 'agency' | 'organization';
  img: string;
}

const Avatar: FC<IAvatar> = ({ wasOnline, from, img }) => (
  <div
    className={cn(css.avatar, {
      _isOffline: wasOnline === 'offline',
      _isOrganization: from === 'organization',
      _isAgency: from === 'agency',
      _isClient: from === 'client',
    })}
  >
    <div
      className={css.avatar__img}
      style={{ backgroundImage: `url(${img})` }}
    />
  </div>
);

export default Avatar;
